import { render, staticRenderFns } from "./extrinsicFactorsNode.vue?vue&type=template&id=86b0c21c&scoped=true&"
import script from "./extrinsicFactorsNode.vue?vue&type=script&lang=js&"
export * from "./extrinsicFactorsNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b0c21c",
  null
  
)

export default component.exports